import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['group']

  validate(event) {
    if (event.submitter?.formNoValidate) return

    const invalid = this.groupTargets.filter((group) => this._isInvalid(group))

    this.groupTargets.forEach((group) => {
      this._errorFor(group)?.classList.toggle(
        'hidden',
        !invalid.includes(group),
      )
    })

    if (invalid.length === 0) return

    event.preventDefault()
    invalid[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
    invalid[0].querySelector('input[type=checkbox]')?.focus()
  }

  clear(event) {
    const group = event.target.closest('[data-checkbox-group-target=group]')
    if (!group || this._isInvalid(group)) return
    this._errorFor(group)?.classList.add('hidden')
  }

  _isInvalid(group) {
    if (group.dataset.checkboxGroupRequired !== 'true') return false
    return !group.querySelector('input[type=checkbox]:checked')
  }

  _errorFor(group) {
    return group.querySelector('[data-checkbox-group-error]')
  }
}
